import axios from 'axios';
import {
  getToken
} from '@/util/auth';

const service = axios.create({
  // baseURL: 'http://localhost:59194/api',
  // baseURL: 'https://crtsurvey.crt-insights.com:8383/TMSWebApi/api',
  baseURL: 'https://portal.sunwardpharma.com/tmsapi/api',
  json: true
});

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    //if (store.getters.token) {
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['X-Token'] = getToken();
    //}
    return config;
  },
  error => {
    // Do something with request error
    //console.log(error); // for debug
    Promise.reject(error);
  }
);

// // respone interceptor
service.interceptors.response.use(
  response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  // response => {
  // const res = response.data
  // if (res.code !== 20000) {
  //     Message({
  //       message: res.message,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })
  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       // 请自行在引入 MessageBox
  //       // import { Message, MessageBox } from 'element-ui'
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  error => {

    const response = error.response;
    console.log(response.data);
    let errormsg = response.data;
    console.log(errormsg.Message);
    // Message({ message: errormsg.Message, type: 'error', duration: 5 * 1000 });
    //throw error;
    return Promise.reject(errormsg.Message);
  }
);

// Add a response interceptor
// service.interceptors.response.use(
//   response => {
//     // Do something with response data
//     return response;
//   },
//   error => {
//     console.log(error);
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );

export default {
  execute(method, resource, data) {
    // inject the accessToken for each request
    return service({
        method,
        url: resource,
        data,
        validateStatus: status => {
          return status < 500;
        }
      })
      .then(req => {
        return req;
      })
      .catch(error => {
        console.log(error);
        window.getApp.$emit('APP_API_ERROR', error);
        //throw error;
      });
  },
  downloadFile(method, resource, data) {
    // inject the accessToken for each request
    return service({
        method,
        url: resource,
        data,
        responseType: 'blob',
        validateStatus: status => {
          if (status == 500) {
            return false;
          } else {
            return true;
          }
        }
      })
      .then(req => {
        return req;
      })
      .catch(error => {
        //throw error;
        window.getApp.$emit('APP_API_ERROR', error);
      });
  },
  getAll(controllerName) {
    return this.execute('get', controllerName);
  },
  getByID(id, controllerName) {
    return this.execute('get', `/` + controllerName + `/?id=${id}`);
  },
  getItem(data, controllerName) {
    return this.execute('post', `/` + controllerName, data);
  },
  create(data, controllerName) {
    // data.addedByUserID = this.$store.state.auth.userId;
    // data.addedDate = new Date();
    return this.execute('post', '/' + controllerName, data);
  },
  update(id, data, controllerName) {
    // data.modifiedByUserID = 2;
    // data.modifiedDate = new Date();
    return this.execute('put', `/` + controllerName + `?id=${id}`, data);
  },
  delete(id, controllerName) {
    return this.execute('delete', `/` + controllerName + `?id=${id}`);
  },
  uploadFile(data, controllerName) {
    return this.execute('post', '/' + controllerName, data);
  },
  downDocument(data, controllerName) {
    return this.downloadFile('get', `/` + controllerName + `/?id=${data}`);
  },
  getByuserId(id, userId, controllerName) {
    //console.log(this.$store.state.auth.userId);
    //let userId = 2;
    return this.execute('get', `/` + controllerName + `/?id=${id}&&userId=${userId}`);
  },
};


// WEBPACK FOOTER //
// ./src/util/api.js